import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=dbb99afa&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=dbb99afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb99afa",
  null
  
)

export default component.exports